import { BASE_COMPONENT } from './../../core/wiz-base-component';
import { ChangeDetectionStrategy, Component, HostBinding, forwardRef, AfterViewInit, OnDestroy } from '@angular/core';
import { WizBaseComponent } from '../../core/wiz-base-component';
import { COMPONENTRESOURCES } from '../../../../../assets/componentresources';
import { IWIZ_COMPONENT} from '../../../interfaces/iwiz-component';
import { WizEvent } from '../../../events/wiz-event';
import { WizEventManager } from '../../../events/wiz-event.manager';

@Component({
  selector: 'wiz-icon',
  template: `<div style="padding: 2px"><ng-content [wizTooltip]="translatedTooltip"></ng-content></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: BASE_COMPONENT, useExisting: forwardRef(() => WizIcon)},
    {provide: WizBaseComponent, useExisting: forwardRef(() => WizIcon)},
    {provide: IWIZ_COMPONENT, useExisting: forwardRef(() => WizIcon)}
  ]
})
export class WizIcon extends WizBaseComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class.wiz-icon-') public wizIconClass: boolean = true;

  @HostBinding('class.disabled-class') public get disabledClass() {
    return this._wizDisabled;
  }

  //##### référence des icones pour le toast
  public static readonly TOAST_SUCCESS = COMPONENTRESOURCES.TOAST_SUCCESS; 
  public static readonly TOAST_WARNING = COMPONENTRESOURCES.TOAST_WARNING;
  public static readonly TOAST_ERROR = COMPONENTRESOURCES.TOAST_ERROR;


  //##### modes de lancement des visions (PROD, QUAL, RE7)
  public static readonly RUN_MODE_TEST = COMPONENTRESOURCES.RUN_MODE_TEST; 
  public static readonly RUN_MODE_QUAL = COMPONENTRESOURCES.RUN_MODE_QUAL;
  public static readonly RUN_MODE_PROD = COMPONENTRESOURCES.RUN_MODE_PROD;



  ngAfterViewInit() {
    WizEventManager.addListener(this, this, 'click', (event: WizEvent) => {
      if (this._wizDisabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
      }
    }, { capture: true });
  }

  ngOnDestroy() {
    WizEventManager.removeListener(this, this, 'click');
  }

  public getFlexShrink(): number {
    return 0;
  }
}
